import React, { useEffect, useState } from 'react';
import AdminLayout from './components/adminlayout';
import { serverURL } from '../constants';
import axios from 'axios';
import UserTable from './components/usertable';

const PaidUsers = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        sessionStorage.setItem('darkMode', false);
        async function fetchData() {
            const response = await axios.get(serverURL + `/api/getpaid`, { headers: { 'x-admin-email': sessionStorage.getItem('email') } });
            setData(response.data);
        }
        fetchData();
    }, []);

    return (
        <AdminLayout>
            <UserTable datas={data} />
        </AdminLayout>
    );
};
export default PaidUsers;
